import store_assurance from '@/store/mods/parametres/assurance'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import ManageAssurSociete from '@/components/parametres/parametre/assurance-societes/manage-assur-societe'
import $ from 'jquery'

export default {
    name: 'assurance-societes',
    components: {
        ManageAssurSociete
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            is_loading: true,
            is_empty: false,
            is_error: false,
            liste_assur_souscripteurs: [],

            fields: [
                { key: 'societe', label: 'Société' },  
                { key: 'prefix', label: 'Préfixe ref. Facture' },
                { key: 'model_forfait', label: 'Modèle forfaitaire' },
                { key: 'prix_unitaire_forfait', label: 'P.U.' },
                { key: 'qte', label: 'Qté' },
                { key: 'montant_forfait', label: 'P.T' },
                { key: 'duree_forfait', label: 'Durée de couverture' },
                { key: 'action', label: 'Action.s' }
            ],
           
            filter: [],
            perPage: -1,
            currentPage: 1,
            action_toggler: 0,
            societe_action_toggler: 0,
            action_data_type: '',

            liste_assurances: [],
            selected_assurance: {},
            selected_societe: {},
        }
    },

    watch: {
        selected_assurance() {
            if (this.selected_assurance.id == 0) {
                $('.all-assur').fadeIn(200)
            } else {
                this.showHideAsssurances()
            }
        }
    },

    computed: {

    },

    mounted() {
        this.fields = [
            { key: 'societe', label: 'Société' },  
            { key: 'prefix', label: 'Préfixe ref. Facture' },
            { key: 'model_forfait', label: 'Modèle forfaitaire' },
            { key: 'prix_unitaire_forfait', label: 'P.U. en '+this.currency_info.principal_currency },
            { key: 'qte', label: 'Qté' },
            { key: 'montant_forfait', label: 'P.T. en '+this.currency_info.principal_currency },
            { key: 'duree_forfait', label: 'Durée de couverture' },
            { key: 'action', label: 'Action.s' }
        ]
        
        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        this.fetchSouscripteurs()
    },

    methods: {
        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        showHideAsssurances() {
            $('.all-assur').fadeOut(200)

            setTimeout(() => {
                $('.s-assur-'+this.selected_assurance.id).fadeIn(100)
            }, 300);
        },

        setListeAssurances() {
            this.liste_assurances = []
            let tmp_assur = {
                id: 0,
                libelle: "Toutes les assurances"
            }
            this.selected_assurance = tmp_assur
            this.liste_assurances.push(tmp_assur)

            this.liste_assur_souscripteurs.forEach(el => {
                let tmp_assur = {
                    id: el.assurance_id,
                    libelle: el.raison_sociale
                }
                this.liste_assurances.push(tmp_assur)
            });
        },

        fetchSouscripteurs() {
            this.is_loading = true
            this.is_error = false

            const data = {}
            store_assurance.getSouscripteurGroupByAssurance(data).then((response) => {
                this.liste_assur_souscripteurs = response
                
                for (let i = 0; i < this.liste_assur_souscripteurs.length; i++) {
                    this.filter[i] = ''
                }

                if (this.liste_assur_souscripteurs.length == 0) {
                    this.is_empty = true 
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
                this.setListeAssurances()
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        configurerSocieteForfaitaire() {
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.action_data_type = 'model_forfait'
            $('.mng-societe-forfaitaire').modal('show')
        },

        configurerMontantForfaitaire() {
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.action_data_type = 'montant_forfait'
            $('.mng-societe-forfaitaire').modal('show')
        },

        edit(data) {
            console.log(">>> ",data);
            this.societe_action_toggler = (this.societe_action_toggler == 0)?1:0
            this.selected_societe = data
            $('.edt-societe').modal('show')
        }
    }
}